import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import { useTranslation } from 'react-i18next';
import DialogActions from '@mui/material/DialogActions';
import { Button } from '@mui/material';
import { TRACKABLE_EVENTS, trackEventBudget } from 'helpers/trackerHelpers';
import { translateBlock } from 'i18n';
import AssociationsGrid from './AssociationsGrid';
import { useGetResourcesByBudgetProposal } from '../helpers/dataHelpers';
import { UseMutateFunction } from '@tanstack/react-query';
import { BudgetBys } from 'business/constants';
import { ResourceBudgetProposalAssociationT } from 'routes/BudgetModule/config/types';
import { getResourceType } from 'routes/BudgetModule/helpers/budgetProposalHelpers';
import { useSelectSecondaryBudgetAxisSourceTable } from 'routes/BudgetModule/components/BudgetWithProvider/SecondaryBudgetAxisSourceTableContext';

export const CreateDraftOperationAssociations: React.FC<{
    closeModal: () => void;
    setAssociations: DispatchState<ResourceBudgetProposalAssociationT[]>;
    associations: ResourceBudgetProposalAssociationT[];
    createDraftOperation: UseMutateFunction<{
        message: string;
    }>;
    exercice: number;
    isDafView: boolean;
    budgetBy: BudgetBys;
}> = ({
    closeModal,
    createDraftOperation,
    setAssociations,
    associations,
    exercice,
    isDafView = false,
    budgetBy,
}) => {
    const { t } = useTranslation();
    const { data: resourcesWithBp, isLoading: resourcesWithBpLoading } =
        useGetResourcesByBudgetProposal({
            budgetBy,
        });
    const sourceTable = useSelectSecondaryBudgetAxisSourceTable();
    const resourceType = getResourceType(budgetBy);
    return (
        <>
            <DialogTitle>
                {t('createDraftOperation.chooseResourcesHeaderTitle', {
                    resourceType: translateBlock(resourceType),
                    context: sourceTable,
                })}
            </DialogTitle>
            <AssociationsGrid
                setAssociations={setAssociations}
                budgetProposalByField={resourceType}
                isLoading={resourcesWithBpLoading}
                resourcesWithBp={resourcesWithBp ?? []}
            />
            <DialogActions>
                <Button onClick={closeModal}>{t('common.close')}</Button>
                <Button
                    disabled={associations.length < 1}
                    onClick={() => {
                        trackEventBudget(
                            isDafView
                                ? TRACKABLE_EVENTS.budget.budgetOverview
                                      .operations.draftOperation.confirmCreation
                                : TRACKABLE_EVENTS.budget.budgetProposal
                                      .draftOperation.confirmCreation,
                            {
                                exercice,
                            },
                        );
                        createDraftOperation();
                    }}
                >
                    {t('common.create')}
                </Button>
            </DialogActions>
        </>
    );
};
